import { Component, ViewEncapsulation, Input, Output, EventEmitter } from "@angular/core";
import { InstanceMonitoringData } from "../../../models";
import * as _ from 'lodash';
import { InstanceMonitoringService } from "../../../services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IActionStatus } from "src/app/shared/interfaces/action-status.interface";

@Component({
    standalone: false,
    selector: 'tr[app-instance-monitoring-unsynchronized-cr-group-ids-row]',
    templateUrl: './i-m-unsynchronized-cr-group-ids-row.component.html',
    styleUrls: ['./i-m-unsynchronized-cr-group-ids-row.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IMUnsynchronizedCRGroupIdsRowComponent {
    constructor(
        private readonly instanceMonitoringService: InstanceMonitoringService,
        private readonly snackBar: MatSnackBar
    ) { }
    @Input()
    instanceMonitoringData: InstanceMonitoringData;

    @Output()
    actionPerformed = new EventEmitter<boolean>();

    state: IActionStatus = { isWaitingActionFinish: false }

    get isInitialized() {
        return !!_.get(this, 'instanceMonitoringData.gridicsInstanceId');
    }

    get needFix() {
        return !!_.get(this, 'instanceMonitoringData.unsynchronizedCRGroupIdsCount', 0);
    }

    async fix() {
        if (!this.needFix) {
            return;
        }
        this.state.isWaitingActionFinish = true;
        this.instanceMonitoringService
            .fixUnsynchronizedCRGroupIds(this.instanceMonitoringData.gridicsInstanceId).
            subscribe(
                updatedRecords => {
                    this.snackBar.open(
                        `${updatedRecords} Calculation Results updated`,
                        'OK',
                        {
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                            duration: 4000
                        });
                    this.actionPerformed.emit(true);
                    this.state.isWaitingActionFinish = false;
                },
                () => {
                    this.actionPerformed.emit(false);
                    this.state.isWaitingActionFinish = false;
                }
            );
    }
}
